import GeneralModel from './GeneralModel';

export default class BoxCheckModel extends GeneralModel {
	constructor(socket) {
		super('box_check', socket);
	}

	_GetData = async () => {
		this.Objects = {};
		this._FireChanged();
	};

	setData = (objs) => {
		for (let i in objs) {
			this.Objects[objs[i].id] = objs[i];
		}
	};
}



// WEBPACK FOOTER //
// ./src/model/BoxCheckModel.js